var lib_core = require("lib-core");

var SymbolMetaData = require("../symbol/symbolMetaData.js");

var SymbolData = function(newMetaData) {
    var self = this;
    this.makeObservableTreeNode();

    this.metaData = this.value("metaData", true);

    this.terminals = this.set("terminals", true);
    this.shapes = this.list("shapes", true);
    this.generators = this.set("generators", true);

    this.terminalNames = new lib_core.NameManager();    // TODO: current namelist should become a shadow, which can be used by the validators and proposal get
    this.terminals.onAdd("nameManager", function(terminal){
        if (self.isAlive() && self.terminalNames.isRegistered('', terminal.name())) terminal.name(self.terminalNames.getProposal('', terminal.name())); // if name of added pad already exist propose a new unique name
        self.terminalNames.register('', terminal.name());
        terminal.name.onChange("nameManager", function(val, old){
            self.terminalNames.remove('', old);
            self.terminalNames.register('', val);
        });
    });
    var nameLists = ["leftNameList","bottomNameList", "rightNameList", "topNameList"];
    this.terminals.onRemove("nameManager", function(terminal){
        self.terminalNames.remove('', terminal.name());
        terminal.name.removeHandlers("nameManager");
    });
    this.generators.onAdd("nameManager", function(generator){
        for (var i in nameLists) {
            var nameList = generator.collections.get(nameLists[i]);
            nameList.forEach(function (idx, name) {
                if (self.isAlive() && self.terminalNames.isRegistered('', name)){  // if name of added pad already exist propose a new unique name
                    name = self.terminalNames.getProposal('', name);
                    nameList.put(idx, name);
                }
                self.terminalNames.register('', name);
            });
            nameList.onBubble("nameManager", function(event){
                if (event.oldValue != undefined) self.terminalNames.remove('', event.oldValue);
                if (event.value != undefined) self.terminalNames.register('', event.value);
            })
        }
    });
    this.generators.onRemove("nameManager", function(generator){
        for (var i in nameLists) {
            var nameList = generator.collections.get(nameLists[i]);
            nameList.forEach(function (idx, name) {
                self.terminalNames.remove('', name);
            });
            nameList.removeHandlers("nameManager");
        }
    });

    this.boundingBox = this.cachedFunction("boundingBox",
        function(){
            var boundingBox = null;
            self.terminals.forEach(function(terminal) {
                var terminalBB = terminal.boundingBox && terminal.boundingBox();
                if (terminalBB) boundingBox = terminalBB.merge(boundingBox);
            });
            self.shapes.forEach(function(index, element){
                var elementBB = element.boundingBox && element.boundingBox();
                if (elementBB) boundingBox = elementBB.merge(boundingBox);
            });
            self.generators.forEach(function(generator) {
                var generatorBB = generator.boundingBox && generator.boundingBox();
                if (generatorBB) boundingBox = generatorBB.merge(boundingBox);
            });
            return boundingBox;
        },
        [this.terminals, this.shapes, this.generators]
    );

    this.isComplete = this.shadow("isComplete",
        function() {
            return self.terminals.size() !== 0
                || self.shapes.size() !== 0
                || self.generators.size() !== 0;
        }, null,
        [this.terminals, this.shapes, this.generators]
    );

    if (newMetaData) {
        var metaData = new SymbolMetaData();
        metaData.name("New Symbol");
        metaData.summary("");
        metaData.description("");
        this.metaData(metaData);
    }
};
lib_core.mixin(SymbolData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(SymbolData, "SymbolData");

module.exports = SymbolData;

SymbolData.prototype.getTerminals = function () {
    return this.terminals;
};

SymbolData.prototype.prepareDescription = function() {  // TODO: search for a better name
    while(!this.generators.isEmpty()){
        this.generators.getOne().expand(true);// expand each generator in description.
    }
};